module.exports = __webpack_public_path__ + "gold.svg?90fc1de09d4d40e969dc8617ed44ed1c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gold.svg
// module id = 109
// module chunks = 0